import { render } from "./PromocionForm.vue?vue&type=template&id=27db3e42"
import script from "./PromocionForm.vue?vue&type=script&lang=js"
export * from "./PromocionForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__